module.exports = __webpack_public_path__ + "static/travel-bg-6825f6c4d6a272ccdbea84dc7c9822cc.jpg";